import { GridIcon, ListIcon } from '../../../components/ui/icons';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { CollectionView } from '../types';

export function CollectionViewControl({
  value,
  onChange,
}: {
  value: CollectionView;
  onChange: (value: CollectionView) => void;
}) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_event, next: CollectionView | null) => next && onChange(next)}
      aria-label="Collection view"
      sx={{
        flexShrink: 0,
        bgcolor: 'background.paper',
        borderRadius: 1,
        // Override the group's joined-button border as well as each button's
        // own border. Match the neighbouring 44px filter and sort controls.
        '&& .MuiToggleButtonGroup-grouped': {
          border: 0,
          margin: 0,
          width: 44,
          height: 44,
          padding: 0,
        },
      }}
    >
      <Tooltip title="Grid view">
        <ToggleButton value="grid" aria-label="Grid view">
          <GridIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="List view">
        <ToggleButton value="list" aria-label="List view">
          <ListIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
